<template>
  <div>
    <!-- 彩蛋1弹窗-领取成功 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg1">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg1">
          <div class="text-style">
            <div>蜗的小家</div>
            <div class="mt30" v-if="activity.spy_no > 0">
              已经迎接了 <span>{{ activity.spy_no }} </span>个访客了
            </div>
            <div class="mt70 mr24" v-if="activity.spy_no > 0">
              人满为患，下次不要再来了！
            </div>
            <div class="mt40 mr24" v-if="activity.spy_no <= 0">
              好像还没迎接过访客，
            </div>
            <div class="mt70 mr24" v-if="activity.spy_no <= 0">
              嗯...要先去外面转转吗？
            </div>
          </div>
          <div class="confirm" @click.stop="isShowEasterEgg1 = false"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowEasterEgg1"></div>
    </div>
    <!-- 彩蛋2弹窗-领取成功 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg2">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg2">
          <div class="text-style">
            <div v-if="activity.god_total > 0">
              蜗已经触发了 <span>{{ activity.god_total }}</span> 次降神!
            </div>
            <div class="mt45" v-if="activity.god_total > 0">
              出现普通神仙蜗还能理解
            </div>
            <div class="mt70" v-if="activity.god_total > 0">
              但Peter你怎么也在啊?
            </div>
            <div v-if="activity.god_total <= 0">
              这个奇怪的供奉台是怎么回事,
            </div>
            <div class="mt45" v-if="activity.god_total <= 0">
              不会还能召唤神龙吧...
            </div>
          </div>
          <div class="confirm" @click.stop="isShowEasterEgg2 = false"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowEasterEgg2"></div>
    </div>
    <!-- 彩蛋3弹窗-领取成功 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg3">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg3">
          <div class="text-style">
            <div>在这些日子中</div>
            <div class="mt30">
              蜗最爱到
              <span>{{ tourMapText(activity.tour_map_count) }} </span>里探索
            </div>
            <div
              class="mt70 mr24"
              v-if="tourMapText(activity.tour_map_count) === '时空孔隙'"
            >
              真是一入时空，深似海啊...
            </div>
            <div
              class="mt70 mr24"
              v-if="tourMapText(activity.tour_map_count) !== '时空孔隙'"
            >
              还记得是什么吸引着鹂嘛？
            </div>
          </div>
          <div class="confirm" @click.stop="isShowEasterEgg3 = false"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowEasterEgg3"></div>
    </div>
    <!-- 彩蛋4弹窗-领取成功 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg4">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg4">
          <div class="text-style">
            <div v-if="activity.drill_cost > 0">
              蜗已经消耗了
            </div>
            <div class="mt30 mr24" v-if="activity.drill_cost > 0">
              <span>{{ activity.drill_cost }}</span> 个钻头用来钻地！
            </div>
            <div class="mt70 mr24" v-if="activity.drill_cost > 0">
              蜗的钻头，可是要突破天际的啊！
            </div>
            <div class="mt30" v-if="activity.drill_cost <= 0">
              穿越者联盟似乎给你留了些东西...
            </div>
            <div class="mt70" v-if="activity.drill_cost <= 0">
              哇，又是奖励！
            </div>
          </div>
          <div class="confirm" @click.stop="isShowEasterEgg4 = false"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowEasterEgg4"></div>
    </div>
    <!-- 彩蛋1弹窗-已领取 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg1_1">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg1-1">
          <div class="text-style">
            <div>蜗的小家</div>
            <div class="mt30" v-if="activity.spy_no > 0">
              已经迎接了 <span>{{ activity.spy_no }} </span>个访客了
            </div>
            <div class="mt70 mr24" v-if="activity.spy_no > 0">
              人满为患，下次不要再来了！
            </div>
            <div class="mt40 mr24" v-if="activity.spy_no <= 0">
              好像还没迎接过访客，
            </div>
            <div class="mt70 mr24" v-if="activity.spy_no <= 0">
              嗯...要先去外面转转吗？
            </div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowEasterEgg1_1"
        @click.stop="isShowEasterEgg1_1 = false"
      ></div>
    </div>
    <!-- 彩蛋2弹窗-已领取 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg2_1">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg2-1">
          <div class="text-style">
            <div v-if="activity.god_total > 0">
              蜗已经触发了 <span>{{ activity.god_total }}</span> 次降神!
            </div>
            <div class="mt45" v-if="activity.god_total > 0">
              出现普通神仙蜗还能理解
            </div>
            <div class="mt70" v-if="activity.god_total > 0">
              但Peter你怎么也在啊?
            </div>
            <div v-if="activity.god_total <= 0">
              这个奇怪的供奉台是怎么回事,
            </div>
            <div class="mt45" v-if="activity.god_total <= 0">
              不会还能召唤神龙吧...
            </div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowEasterEgg2_1"
        @click.stop="isShowEasterEgg2_1 = false"
      ></div>
    </div>
    <!-- 彩蛋3弹窗-已领取 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg3_1">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg3-1">
          <div class="text-style">
            <div>在这些日子中</div>
            <div class="mt30">
              蜗最爱到
              <span>{{ tourMapText(activity.tour_map_count) }} </span>里探索
            </div>
            <div
              class="mt70 mr24"
              v-if="tourMapText(activity.tour_map_count) === '时空孔隙'"
            >
              真是一入时空，深似海啊...
            </div>
            <div
              class="mt70 mr24"
              v-if="tourMapText(activity.tour_map_count) !== '时空孔隙'"
            >
              还记得是什么吸引着鹂嘛？
            </div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowEasterEgg3_1"
        @click.stop="isShowEasterEgg3_1 = false"
      ></div>
    </div>
    <!-- 彩蛋4弹窗-已领取 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowEasterEgg4_1">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="easter-egg4-1">
          <div class="text-style">
            <div v-if="activity.drill_cost > 0">
              蜗已经消耗了
            </div>
            <div class="mt30 mr24" v-if="activity.drill_cost > 0">
              <span>{{ activity.drill_cost }}</span> 个钻头用来钻地！
            </div>
            <div class="mt70 mr24" v-if="activity.drill_cost > 0">
              蜗的钻头，可是要突破天际的啊！
            </div>
            <div class="mt30" v-if="activity.drill_cost <= 0">
              穿越者联盟似乎给你留了些东西...
            </div>
            <div class="mt70" v-if="activity.drill_cost <= 0">
              哇，又是奖励！
            </div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowEasterEgg4_1"
        @click.stop="isShowEasterEgg4_1 = false"
      ></div>
    </div>
    <!-- 抽奖弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowLottery">
      <div class="lottery">
        <div class="decoration">
          <div v-if="random == 4" class="wrap-border"></div>
        </div>
        <div class="welfare">
          <div v-if="random == 3" class="wrap-border"></div>
        </div>
        <div class="gift-box">
          <div v-if="random == 2" class="wrap-border"></div>
        </div>
        <div class="fluorite">
          <div v-if="random == 8" class="wrap-border"></div>
        </div>
        <div class="t-shirt">
          <div v-if="random == 1" class="wrap-border"></div>
        </div>
        <div class="white-tadpole">
          <div v-if="random == 9" class="wrap-border"></div>
        </div>
        <div class="raffle-ticket">
          <div v-if="random == 6" class="wrap-border"></div>
        </div>
        <div class="astragalite">
          <div v-if="random == 7" class="wrap-border"></div>
        </div>
        <div class="commemorative-coin">
          <div v-if="random == 5" class="wrap-border"></div>
        </div>
        <div class="lottery-detail">
          <div class="detail-bg1" v-if="lotteryDetailList[0]">
            <div>
              <p>{{ dateText(lotteryDetailList[0].created_at) }}</p>
              <p>{{ remarkText(lotteryDetailList[0].remark) }}</p>
            </div>
          </div>
          <div class="detail-bg2" v-if="lotteryDetailList[1]">
            <div>
              <p>{{ dateText(lotteryDetailList[1].created_at) }}</p>
              <p>{{ remarkText(lotteryDetailList[1].remark) }}</p>
            </div>
          </div>
          <div class="detail-bg3" v-if="lotteryDetailList[2]">
            <div>
              <p>{{ dateText(lotteryDetailList[2].created_at) }}</p>
              <p>{{ remarkText(lotteryDetailList[2].remark) }}</p>
            </div>
          </div>
        </div>
        <div class="yellowbird"></div>
        <div class="moom"></div>
        <div class="lottery-btn" @click="requestLottery">
          <div>剩余次数：{{ lotteryCount }}</div>
        </div>
        <div
          :class="is_get_prize ? 'explain' : 'is-get-prize'"
          @click.stop="isShowActivityDetail = true"
        ></div>
        <div
          class="area"
          v-if="is_get_prize"
          @click.stop="isShowAreaDialog = true"
        >
          <div class="red" v-if="!phone"></div>
        </div>
      </div>
      <div class="close-bg"></div>
      <div class="close-btn" @click.stop="isInLottere"></div>
    </div>
    <!-- 填写地址弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowAreaDialog">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="area-dialog">
          <div class="wrap">
            <div class="compellation">
              <input type="text" placeholder="收件人姓名" v-model="name" />
            </div>
            <div class="phone">
              <input type="text" placeholder="联系电话" v-model="phone" />
            </div>
            <div class="clothes-size" v-if="isClothes"></div>
            <div
              :class="size == 'S' ? 'checked' : 'size-bg'"
              @click="size = 'S'"
              v-if="isClothes"
            >
              S
            </div>
            <div
              :class="size == 'M' ? 'checked ml207' : 'size-bg ml207'"
              @click="size = 'M'"
              v-if="isClothes"
            >
              M
            </div>
            <div
              :class="size == 'L' ? 'checked ml279' : 'size-bg ml279'"
              @click="size = 'L'"
              v-if="isClothes"
            >
              L
            </div>
            <div
              :class="size == 'XL' ? 'checked ml351' : 'size-bg ml351'"
              @click="size = 'XL'"
              v-if="isClothes"
            >
              XL
            </div>
            <div
              :class="size == 'XXL' ? 'checked mt115' : 'size-bg mt115'"
              @click="size = 'XXL'"
              v-if="isClothes"
            >
              XXL
            </div>
            <div
              :class="
                size == '3XL' ? 'checked mt115 ml207' : 'size-bg mt115 ml207'
              "
              @click="size = '3XL'"
              v-if="isClothes"
            >
              3XL
            </div>
            <div
              :class="
                size == '4XL'
                  ? 'checked size-bg mt115 ml279'
                  : 'size-bg mt115 ml279'
              "
              @click="size = '4XL'"
              v-if="isClothes"
            >
              4XL
            </div>
            <div
              class="size"
              @click="isShowSizeDialog = true"
              v-if="isClothes"
            ></div>
            <div class="tips" v-if="isClothes"></div>
            <div :class="isClothes ? 'area' : 'area1'">
              <textarea
                type="textarea"
                placeholder="填写收货地址"
                v-model="area"
              ></textarea>
            </div>
            <div
              :class="isClothes ? 'submit-btn' : 'submit-btn1'"
              @click="submit"
            ></div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowAreaDialog"
        @click.stop="isShowAreaDialog = false"
      ></div>
    </div>
    <!-- 活动详情弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowActivityDetail">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="activity-detail">
          <div class="detail">
            <p>1、活动时间：2023年6月19日-7月14日23:59；</p>
            <p>2、登陆青瓷账号、渠道玩家绑定角色即可观影蜗牛年度报告；</p>
            <p>
              3、全服数据的截取时间为2023年6月11日；
            </p>
            <p>
              4、年度报告：收到猴子们的年度剧场观影邀请，玩家可以在年度报告中，查看游戏角色的相关数据；在观影过程中，共有4个彩蛋可以进行收集，并获取奖励；
            </p>
            <p>
              5、抽奖活动：本次活动每个账号可免费获得3次抽奖机会，参与周年抽奖；
            </p>
            <p>
              6、本次活动中获得的虚拟道具奖励，将直接发送至绑定角色的邮箱中；
            </p>
            <p>
              7、实物奖励中奖的玩家需要在2023年7月14日23:59前填写收件信息；逾期未填写将视为玩家自动放弃领奖资格；
            </p>
            <p>
              8、收货地址信息以玩家最后一次填写并确认为准；若因玩家个人的原因造成无法顺利收货，由玩家本人自行承担后果；
            </p>
            <p>9、实物奖励将在14个工作日内发出；</p>
            <p>10、本次活动的最终解释权归《最强蜗牛》所有。</p>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowActivityDetail"
        @click.stop="isShowActivityDetail = false"
      ></div>
    </div>
    <!-- 分享奖励弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowShareDialog">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="share-dialog">
          <div class="btn" @click.stop="isShowShareDialog = false">
            <div v-if="!isAlreadyReceived" class="confirm"></div>
            <div v-else class="already-received"></div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="isShowShareDialog"
        @click.stop="isShowShareDialog = false"
      ></div>
    </div>
    <!-- 标签弹窗 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowTapDialog">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="describe-dialog">
          <div class="describe-list">
            <div v-for="(item, index) in describeSelectList" :key="index">
              <div
                :class="
                  describeSelect == index ? 'describe-border' : 'describe-bg'
                "
                @click="describeSelect = index"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="nickname-list">
            <div v-for="(item, index) in nicknameSelectList" :key="index">
              <div
                :class="
                  nicknameSelect == index ? 'nickname-border' : 'nickname-bg'
                "
                @click="nicknameSelect = index"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="describe-btn" @click="describeConfirm"></div>
        </div>
      </transition>
      <div class="close-bg"></div>
      <div class="close-btn" @click.stop="closeTapDialog"></div>
    </div>
    <!-- 彩蛋4弹窗-已领取 -->
    <div class="popup_wrap1 logout-wrap" v-show="isShowSizeDialog">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="size-dialog">
          <div class="close" @click="isShowSizeDialog = false"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="isShowSizeDialog"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 彩蛋一弹窗-领取成功
      isShowEasterEgg1: false,
      // 彩蛋二弹窗-领取成功
      isShowEasterEgg2: false,
      // 彩蛋三弹窗-领取成功
      isShowEasterEgg3: false,
      // 彩蛋四弹窗-领取成功
      isShowEasterEgg4: false,
      // 彩蛋一弹窗-已领取
      isShowEasterEgg1_1: false,
      // 彩蛋二弹窗-已领取
      isShowEasterEgg2_1: false,
      // 彩蛋三弹窗-已领取
      isShowEasterEgg3_1: false,
      // 彩蛋四弹窗-已领取
      isShowEasterEgg4_1: false,
      // 抽奖弹窗
      isShowLottery: false,
      // 抽奖样式渲染随机数
      random: 0,
      // 填写地址弹窗
      isShowAreaDialog: false,
      // 活动详情弹窗
      isShowActivityDetail: false,
      // 分享奖励弹窗
      isShowShareDialog: false,
      // 是否已领取
      isAlreadyReceived: false,
      // 标签弹窗
      isShowTapDialog: false,
      // 衣服尺寸弹窗
      isShowSizeDialog: false,
      // 姓名
      name: "",
      name1: "",
      // 联系方式
      phone: "",
      phone1: "",
      // 地址
      area: "",
      area1: "",
      // 抽奖记录
      lotteryDetailList: [],
      // 是否在抽奖中
      time: 0,
      // 是否抽中实物
      is_get_prize: false,
      // 活动信息
      activity: "",
      // 抽奖速度
      speed: 250,
      // 定时器
      timer: null,
      // 抽中的奖品id
      prizeId: -1,
      lotteryCount: 0,
      // 标签一数组
      describeSelectList: [
        { name: "欧气爆棚的", id: 1 },
        { name: "氪金变强的", id: 2 },
        { name: "疯狂进化的", id: 3 },
        { name: "真香警告的", id: 4 },
        { name: "整点薯条的", id: 5 },
        { name: "不讲武德的", id: 6 },
        { name: "觉醒替身的", id: 7 },
        { name: "前往弑神的", id: 9 },
        { name: "热心公益的", id: 10 },
        { name: "变成西瓜头的", id: 14 },
        { name: "少女祈祷中的", id: 15 },
        { name: "最懂蜗牛的", id: 16 },
        { name: "脚穿切尔西的", id: 17 },
        { name: "吸收氮磷钾的", id: 18 },
        { name: "练习两年半的", id: 19 },
        { name: "保留原味的", id: 20 }
      ],
      // 标签二数组
      nicknameSelectList: [
        { name: "蜗牛", id: 1 },
        { name: "黄鹂鸟", id: 2 },
        { name: "独眼巨人", id: 3 },
        { name: "穿越者", id: 4 },
        { name: "咕咕鸽子", id: 5 },
        { name: "食腐活尸", id: 6 },
        { name: "鲜血恶魔", id: 7 },
        { name: "裂变异种", id: 9 },
        { name: "战车机械", id: 10 },
        { name: "下头蜗", id: 14 },
        { name: "修女和鱼", id: 15 },
        { name: "川建国", id: 16 },
        { name: "蓝色妖姬", id: 17 },
        { name: "金坷垃", id: 18 },
        { name: "小鸡子", id: 19 },
        { name: "九转大肠", id: 20 }
      ],
      // 标签一
      describeSelect: 0,
      describeSelectName: "欧气爆棚的",
      // 标签二
      nicknameSelect: 0,
      nicknameSelectName: "蜗牛",
      size: "S",
      clothesSize: "S",
      isClothes: false
    };
  },
  created() {},
  mounted() {},
  watch: {
    isShowShareDialog: {
      handler(newValue, oldValue) {
        if (newValue === false) {
          this.$emit("backHomepage");
        }
      }
    },
    lotteryDetailList: {
      handler(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          this.isLotterClothes(newValue);
        }
      }
    },
    isShowAreaDialog: {
      handler(newValue, oldValue) {
        if (newValue === false) {
          if (this.size != this.clothesSize) {
            this.size = this.clothesSize;
          }
          if (this.name != this.name1) {
            this.name = this.name1;
          }
          if (this.area != this.area1) {
            this.area = this.area1;
          }
          if (this.phone != this.phone1) {
            this.phone = this.phone1;
          }
        }
      }
    }
  },
  methods: {
    // 修改标签的方法
    describeConfirm() {
      this.describeSelectName = this.describeSelectList[
        this.describeSelect
      ].name;
      this.nicknameSelectName = this.nicknameSelectList[
        this.nicknameSelect
      ].name;
      this.$emit(
        "describeConfirm",
        this.describeSelectName,
        this.nicknameSelectName
      );
      this.isShowTapDialog = false;
    },
    // 关闭标签选择弹窗
    closeTapDialog() {
      for (let i = 0; i < this.describeSelectList.length; i++) {
        if (this.describeSelectName === this.describeSelectList[i].name) {
          this.describeSelect = i;
        }
      }
      for (let i = 0; i < this.nicknameSelectList.length; i++) {
        if (this.nicknameSelectName === this.nicknameSelectList[i].name) {
          this.nicknameSelect = i;
        }
      }
      this.isShowTapDialog = false;
    },
    // 抽奖方法
    requestLottery() {
      if (this.time > 0) {
        return;
      }
      if (this.lotteryCount == 0) {
        this.$emit("tipsMessage", "很抱歉,您已经没有抽奖次数了", 2000);
        return;
      }
      // 随机数抽奖方式
      // this.$emit("createRandom");
      // 顺时针抽奖方式
      this.clockwiseLottery();
      this.$emit("lotteryTime");
    },
    // 顺时针抽奖
    clockwiseLottery() {
      if (
        this.prizeId !== -1 &&
        this.random !== 0 &&
        this.prizeId !== this.random
      ) {
        if (this.random == 0) {
          this.random = 1;
        } else if (this.random == 1) {
          this.random = 4;
        } else if (this.random == 4) {
          this.random = 3;
        } else if (this.random == 3) {
          this.random = 2;
        } else if (this.random == 2) {
          this.random = 5;
        } else if (this.random == 5) {
          this.random = 9;
        } else if (this.random == 9) {
          this.random = 8;
        } else if (this.random == 8) {
          this.random = 7;
        } else if (this.random == 7) {
          this.random = 6;
        } else if (this.random == 6) {
          this.random = 1;
        }
        this.timer = setTimeout(() => {
          this.clockwiseLottery();
        }, this.speed);
      } else if (this.prizeId == this.random) {
        this.$emit("requestLotteryDetail");
        this.time = 0;
        this.prizeId = -1;
        clearTimeout(this.timer);
        this.$emit("changeTime", 0);
      } else {
        if (this.random == 0) {
          this.random = 1;
        } else if (this.random == 1) {
          this.random = 4;
        } else if (this.random == 4) {
          this.random = 3;
        } else if (this.random == 3) {
          this.random = 2;
        } else if (this.random == 2) {
          this.random = 5;
        } else if (this.random == 5) {
          this.random = 9;
        } else if (this.random == 9) {
          this.random = 8;
        } else if (this.random == 8) {
          this.random = 7;
        } else if (this.random == 7) {
          this.random = 6;
        } else if (this.random == 6) {
          this.random = 1;
        }
        this.timer = setTimeout(() => {
          this.clockwiseLottery();
        }, this.speed);
      }
    },
    // 如果在抽奖中不允许关闭弹窗
    isInLottere() {
      if (this.time > 0) {
        this.$emit("tipsMessage", "正在抽奖中，请勿关闭！", 2000);
        return;
      } else {
        this.isShowLottery = false;
      }
    },
    // 保存地址
    submit() {
      if (!this.name) {
        return this.$emit("tipsMessage", "请填写收件人姓名", 2000);
      }
      if (!this.phone || this.phone.length != 11) {
        return this.$emit("tipsMessage", "请填写正确的联系电话", 2000);
      }
      if (!this.area) {
        return this.$emit("tipsMessage", "请填写收货地址", 2000);
      }
      this.clothesSize = this.size;
      this.phone1 = this.phone;
      this.name1 = this.name;
      this.area1 = this.area;
      this.$emit("requestAddress", {
        name: this.name,
        phone: this.phone,
        address: this.area + "-" + this.size
      });
      this.isShowAreaDialog = false;
    },
    // 时间戳转日期
    dateText(timestamp) {
      const date = new Date(timestamp.replace(/-/g, "/"));
      const Y = date.getFullYear();
      const M = date.getMonth() + 1;
      const D = date.getDate();
      const hour = date.getHours();
      const minutes = date.getMinutes();
      let time = Y + "年" + M + "月" + D + "日" + hour + ":" + minutes;
      return time;
    },
    // 礼品转文本
    remarkText(remark) {
      let text = "";
      if (remark.indexOf("获得") !== -1) {
        text = remark.slice(2);
      } else {
        text = remark;
      }
      return text;
    },
    // 探索地图转文本
    tourMapText(tour_map_count) {
      let text = "时空孔隙";
      if (!tour_map_count) {
        return;
      }
      if (tour_map_count["9"] > 0) {
        text = "时空孔隙";
      } else if (tour_map_count["8"] > 0) {
        text = "天竺";
      } else if (tour_map_count["7"] > 0) {
        text = "希域";
      } else if (tour_map_count["6"] > 0) {
        text = "埃罗";
      } else if (tour_map_count["5"] > 0) {
        text = "英伦";
      } else if (tour_map_count["4"] > 0) {
        text = "米国";
      } else if (tour_map_count["3"] > 0) {
        text = "华夏";
      } else if (tour_map_count["2"] > 0) {
        text = "扶桑";
      } else if (tour_map_count["1"] > 0) {
        text = "高丽";
      }
      return text;
    },
    // 判断抽奖是否抽到衣服
    isLotterClothes(lotteryDetailList) {
      if (lotteryDetailList.length > 0) {
        for (let i = 0; i < lotteryDetailList.length; i++) {
          if (lotteryDetailList[i].prize_id != 1) {
            this.isClothes = false;
          } else {
            return (this.isClothes = true);
          }
        }
      } else {
        this.isClothes = false;
      }
    }
  }
};
</script>

<style lang="less" scope>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/triennial/components/dialog.vue